module.exports = __webpack_public_path__ + "static/media/head.200d5225.png";